export default "__VITE_ASSET__n$1aZp6O__"